import { render } from "./PromotionCreateComponent.vue?vue&type=template&id=17ca633c"
import script from "./PromotionCreateComponent.vue?vue&type=script&lang=js"
export * from "./PromotionCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/promotions/PromotionCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17ca633c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17ca633c', __exports__)) {
    api.reload('17ca633c', __exports__)
  }
  
  module.hot.accept("./PromotionCreateComponent.vue?vue&type=template&id=17ca633c", () => {
    api.rerender('17ca633c', render)
  })

}


export default __exports__